import React, { useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';

import CardWorkflow from '@/components/card/CardWorkflow';
import WorkflowSkeleton from '@/contents/homev2/workflow/Skeleton';
import CardWorkflowForOldModel from '@/components/card/CardWorkflowForOldModel';
import { useDisclosure } from '@nextui-org/react';
import RemixCommon from '@/layouts/remix-common';
import { toast } from 'react-toastify';
import { ShowCase } from '@/app/showcase/constants';
import ClientOnly from '@/components/client-only';
import RenderWhen from '@/components/RenderWhen';
import NoData from '@/components/NoData';

const ListShowcase: React.FC<{
  listShowcase: ShowCase[];
  isLoading: boolean;
  currentPage: number;
  loadMore: (page: number) => void;
}> = ({ listShowcase, isLoading, currentPage, loadMore }) => {
  const [modelSelect, setModelSelect] = useState<any>();

  const useModalRemix = useDisclosure({
    onClose() {
      document.body.style.removeProperty('overflow');
      setModelSelect(undefined);
    },
  });
  const { onOpen } = useModalRemix;

  const handleOpenModel = (model: any) => {
    if (model?.status === 4) {
      toast.error('Model maintenance!');
    } else {
      document.body.style.overflow = 'hidden';
      setModelSelect(model);
      onOpen();
    }
  };

  return (
    <div className="main-container py-8 sm:py-6">
      {modelSelect && <RemixCommon useModalRemix={useModalRemix} modelSelect={modelSelect} />}
      <ClientOnly skeleton={<WorkflowSkeleton items={8} cols={4} />}>
        <RenderWhen>
          <RenderWhen.If isTrue={listShowcase.length === 0 && !isLoading}>
            <NoData />
          </RenderWhen.If>
          <RenderWhen.If isTrue={listShowcase.length > 0}>
            <InfiniteScroll
              style={{ overflow: '' }}
              dataLength={listShowcase?.length}
              next={() => {
                if (listShowcase?.length !== 0) {
                  loadMore(currentPage + 1);
                }
              }}
              hasMore
              loader=""
            >
              <div className="grid grid-cols-4 gap-4 md:grid-cols-2 sm:gap-2">
                {listShowcase?.map((showcase: any) => (
                  <div key={showcase.id}>
                    {showcase.isWorkflow ? (
                      <CardWorkflow
                        totalUse={showcase.totalUsedTimes}
                        totalLike={showcase.totalReactions}
                        id={showcase.id}
                        image={showcase?.previews[0] ?? showcase.picture}
                        title={showcase.name}
                        status={showcase.status}
                        provider={showcase.provider}
                        nodeCount={showcase.workflow?.nodeCount}
                      />
                    ) : (
                      <div onClick={() => handleOpenModel(showcase)}>
                        <CardWorkflowForOldModel
                          totalUse={showcase.totalUsedTimes}
                          totalLike={showcase.totalReactions}
                          url={showcase.picture ?? showcase.cover}
                          title={showcase.name}
                          provider={showcase.provider}
                        />
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </InfiniteScroll>
          </RenderWhen.If>
        </RenderWhen>
      </ClientOnly>
    </div>
  );
};

export default ListShowcase;
